import 'jquery-ui';
import ko from 'knockout';
import { BlockPageHelper } from '../Helpers/helpers';
import { post } from "jquery";
import { Modal } from "bootstrap";
import { Toast } from "bootstrap";
const Genesis = require("../Genesis.js");
import { CategoryPathComponent } from '../Shared/CategoryPath/CategoryPathComponent';
let AutoComplete = require("./adhocworkorder.js");

export class ISiteMobileWorkOrderEditPage {
    private modal: Modal | null = null;

    private category: CategoryPathComponent = new CategoryPathComponent({
        ModalId: 'classificationModal',
        Url: Genesis.url('/WorkOrder/_CategoryPath'),
        PathId: 'categoryPath',
        SelectButtonId: 'selectCategoryButton',
        IsReadOnly: false,
        PreventParentSelection: true,
        AllowMultiSelect: false,
        IsRequired: true,
        FormId: "WorkOrderForm"
    });

    constructor() { }
    public Init() {
        AutoComplete();
        $("#classificationModal").detach().appendTo("#modalContainerPlaceholder");

        let $elements = $("[id^='classificationModal']");
        while ($elements.length >= 2) {
            $elements.first().remove();
            $elements = $("[id^='classificationModal']");
        }


        try {
            ko.applyBindings(this.category);
        }
        catch (e) {
            // Bindings already created, no need to do anything
        }
        $('#WorkOrderForm').off('submit');
        $("#saveWorkOrder").click((e: any) => {
            BlockPageHelper.block();
            const recordid = $('#RecordId').val();

            const form = $('#WorkOrderForm')[0] as HTMLFormElement;
            if (form !== null) {
                this.ValidateCost(form, "CostEstimated", "Please enter a Valid Estimated Cost");
                this.validateAutoComplete(form, "contactSearch", "ContactId");
                this.validateAutoComplete(form, "propertySearch", "PropertyId");
                this.validateAutoComplete(form, "supplierSearch", "SupplierId");
                this.validateAutoComplete(form, "engineerSearch", "EngineerId");
                this.category.validateCategorySelected();
                if (!form.checkValidity()) {
                    form.classList.add('was-validated');
                    BlockPageHelper.unblock();
                    return false;
                }
                else {
                    if ($("#WorkOrderType").val() == "snag") {
                        this.promptUserForServiceRequest(e);
                    }
                    else {
                        this.SubmitWOForm();
                    }
                }
            }
        });

        $("#saveWorkOrderNew").click((e: any) => {
            BlockPageHelper.block();
            const recordid = $('#RecordId').val();
            $("#IsCreateandNew").val("true");
            const form = $('#WorkOrderForm')[0] as HTMLFormElement;
            if (form !== null) {
                this.ValidateCost(form, "CostEstimated", "Please enter a Valid Estimated Cost");
                this.validateAutoComplete(form, "contactSearch", "ContactId");
                this.validateAutoComplete(form, "propertySearch", "PropertyId");
                this.validateAutoComplete(form, "supplierSearch", "SupplierId");
                this.validateAutoComplete(form, "engineerSearch", "EngineerId");
                this.category.validateCategorySelected();
                if (!form.checkValidity()) {
                    form.classList.add('was-validated');
                    BlockPageHelper.unblock();
                    return false;
                }
                else {
                    if ($("#WorkOrderType").val() == "snag") {
                        this.promptUserForServiceRequest(e);
                    }
                    else {
                        this.SubmitWOForm();
                    }
                }
            }
        });

        $("#selfFixFilterAsset").click(() => this.ShowAssetListData());
        if ($("#linkNewServiceRequest").length > 0) {
            $("#linkNewServiceRequest").click(() => {
                $("#LinkToServiceRequest").val("");
                BlockPageHelper.block();
                this.SubmitWOForm();
            });
        }
        if ($("#linkServiceRequest").length > 0) {
            $("#linkServiceRequest").click(() => {
                BlockPageHelper.block();
                this.SubmitWOForm();
            });
        }

        $("#getGeoLocation").click(() => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => this.GetPropertiesForLocation(position));
            }
        });

        $("#snagSelectProject").click(() => this.ShowProjectListData());

        const queryString = window.location.search;
        if (queryString !== null) {
            const searchParams = new URLSearchParams(queryString);
            const projId = searchParams.get("ProjectId");
            if (projId != null) {
                $("#Projectid").val(projId);
                this.processRecordName(parseInt(projId, 10), "snagProjectSearch");
            }
            const propId = searchParams.get("PropertyId");
            if (propId != null) {
                $("#PropertyId").val(propId);
                this.processRecordName(parseInt(propId, 10), "propertySearch");
            }
        }

        $("#propertySearch").on("change input", function () {
            $("#snagProjectSearch").val("");
            $("#assetSearch").val("");
            $("#ProjectId").val("");
            $("#AssetId").val("");
        });
    }

    private GetPropertiesForLocation(position: GeolocationPosition) {
        const modalPL = document.getElementById('propertyListModal');
        if (modalPL !== null) {
            this.modal = new Modal(modalPL, { backdrop: 'static', keyboard: false });
            this.modal.show();
        }

        const _getPropertiesUrl = Genesis.url('/WorkOrder/GetNearestProperties');
        post({
            url: _getPropertiesUrl,
            data:
            {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            }
        }).then((result) => {
            $("#propertyListPlaceHolder").html(result);

            $(".btnpropertyselect").click((e) => {
                this.PropertySelect($(e.target));
            });
        });
    }

    private SubmitWOForm() {
        const formData = $("#WorkOrderForm").serialize();
        var saveWo: { [key: string]: string } = {};
        $.each(formData.split("&"), function (index, item) {
            var pair = item.split("=");
            saveWo[pair[0]] = decodeURIComponent(pair[1]);
        });
        const url = Genesis.url('/WorkOrder/SaveWo');
        $.post(url, { saveWo: saveWo }, function (responseResult) {
            if (responseResult.status) {
                var msgSuccess = Toast.getOrCreateInstance("#msgSuccess");
                msgSuccess.show();
                const redirectUrl = Genesis.url(responseResult.redirectUrl);
                window.location.href = redirectUrl;
            }
            else {
                BlockPageHelper.unblock();
                var msgFailure = Toast.getOrCreateInstance("#msgFailure");
                msgFailure.show();
            }
        });
    }

    private processRecordName(recordid: number, searchElement: string) {
        if (recordid !== null) {
            $.ajax({
                url: Genesis.url('/WorkOrder/GetRecordById'),
                type: "GET",
                dataType: "json",
                data: { recordId: recordid },
                success: (response) => {
                    $("#" + searchElement).val(response);
                }
            });
        }
    }

    private validateAutoComplete(form: any, searchField: string, idField: string) {
        const search = form.elements[searchField];
        const id = form.elements[idField];
        if (search !== null && search != undefined) {
            search.setCustomValidity('');
            if (id.value === '0') {
                search.setCustomValidity('invalid');
                search.classList.add("invalid");
            }
        }
    }

    private ValidateCost(form: any, idField: string, message: string) {
        const costField = form.elements[idField];
        if (costField.value !== '') {
            costField.setCustomValidity('');
            if (!$.isNumeric(costField.value)) {
                costField.setCustomValidity('invalid');
                costField.classList.add("invalid");
                $('#' + idField).next().text(message);
            }
        }
    }

    public ShowAssetListData() {
        const propertyid = $("#PropertyId").val();
        const locationid = $("#locationsDropdown").val();

        $("#assetViewPlaceHolder").hide();
        $("#assets-results").show();

        const modalEl = document.getElementById('assetListModal');
        if (modalEl !== null) {
            this.modal = new Modal(modalEl, { backdrop: 'static', keyboard: false });
            this.modal.show();
        }

        if (propertyid != 0) {
            $("#assetListPlaceHolder").show().html("<span class='m-3'>Loading...</span>");

            $.ajax({
                url: "AssetFilter",
                type: "POST",
                dataType: "html",
                data: { propertyId: propertyid, locationId: locationid },
                success: (response) => {
                    $("#assetListPlaceHolder").html(response);

                    $(".btnassetview").click((e) => {
                        this.AssetView($(e.target));
                    });

                    $(".btnassetselect").click((e) => {
                        this.AssetSelect($(e.target));
                    });
                }
            })
        }
        else {
            $("#assetListPlaceHolder").show().html('<div class="alert bg-red-dark" role="alert"><span class="alert-icon color-white"> <i class="fa fa-times-circle font-18" ></i></span><h4 class="color-white" >No Property Selected</h4><strong class="alert-icon-text color-white" >You must select a property before searching for an asset.</strong> </div>');
            $("#assets-results").hide();
            return;
        }
    }

    public ShowProjectListData() {
        const propertyid = $("#PropertyId").val();
        $("#projectListPlaceHolder").hide();
        $("#project-results").show();

        const modalEl = document.getElementById('projectListModal');
        if (modalEl !== null) {
            this.modal = new Modal(modalEl, { backdrop: 'static', keyboard: false });
            this.modal.show();
        }
        if (propertyid != 0) {
            $("#projectListPlaceHolder").show().html("<span class='m-3'>Loading...</span>");
            $.ajax({
                url: "ProjectFilter",
                type: "POST",
                dataType: "html",
                data: { propertyId: propertyid },
                success: (response) => {
                    $("#projectListPlaceHolder").html(response);
                    $(".btnprojectselect").click((e) => {
                        this.ProjectSelect($(e.target));
                    });
                }
            })
        }
        else {
            $("#projectListPlaceHolder").show().html('<div class="alert bg-red-dark" role="alert"><span class="alert-icon color-white"> <i class="fa fa-times-circle font-18" ></i></span><h4 class="color-white" >No Property Selected</h4><strong class="alert-icon-text color-white" >You must select a property before searching for the project.</strong> </div>');
            $("#project-results").hide();
            return;
        }
    }

    private PropertySelect(e: any) {
        var propertyId = $(e).data("propertyid");
        var propertyName = $(e).data("propertyname");
        $("#propertySearch").val(propertyName);
        $("#PropertyId").val(propertyId);

        AutoComplete();

        if (this.modal !== null) {
            this.modal.hide();
        }
    }

    private AssetSelect(e: any) {
        var assetId = $(e).data("assetid");
        var assetName = $(e).data("assetname");
        $("#assetSearch").val(assetName);
        $("#AssetId").val(assetId);

        if (this.modal !== null) {
            this.modal.hide();
        }
    }

    private ProjectSelect(e: any) {
        var projectId = $(e).data("projectid");
        var projectName = $(e).data("projectname");
        $("#snagProjectSearch").val(projectName);
        $("#ProjectId").val(projectId);

        if (this.modal !== null) {
            this.modal.hide();
        }
    }

    public AssetView(e: any) {
        var assetId = $(e).data("assetid");

        if (assetId != 0) {
            $.ajax({
                url: "AssetView",
                type: "POST",
                dataType: "html",
                data: { assetId: assetId },
                success: (response) => {
                    $("#assetViewPlaceHolder").html(response);
                    this.ShowAssetView();
                }
            })
        }
    }

    private ShowAssetView() {
        $("#assetViewPlaceHolder").show();
        $("#assetViewgoBack").show();

        $("#assetListPlaceHolder").hide();
        $("#assetViewPlaceHolder").show();
        $("#closeAddAssetButtons").hide();

        $(".btnassetselect").click((e) => {
            this.AssetSelect($(e.target));
        });

        $("#ViewAssetBack").click((e) => {
            $("#assetListPlaceHolder").show();
            $("#assetViewPlaceHolder").hide();
            $("#closeAddAssetButtons").show();
        });
    }

    public promptUserForServiceRequest(e: any): void {
        const propertyId = $("#PropertyId").val();
        const _checkSRurl = Genesis.url('/WorkOrder/CheckExistingServiceRequests');
        post({
            url: _checkSRurl,
            data:
            {
                propertyId: propertyId,
            }
        }).then((result) => {
            const srListModal = document.getElementById('serviceRequestListModal');
            if (srListModal !== null) {
                $("#serviceRequestListPlaceHolder").html(result);
                this.modal = new Modal(srListModal, { backdrop: 'static' });

                if (this.modal !== null) {
                    BlockPageHelper.unblock();
                    this.modal.show();
                    this.ShowServiceRequestView(e);
                }
            }
        });
    };

    private ShowServiceRequestView(e: any) {
        $(".btnservicerequestselect").click((e) => {
            const actionButtons = document.querySelectorAll(".btnservicerequestselect")
            actionButtons.forEach(btn => {
                (btn as HTMLButtonElement).disabled = true;
            });
            $(e.currentTarget).prop("disabled", false);
            $("#LinkToServiceRequest").val($(e.currentTarget).data("servicerequestid"));
        });
    }

    private displayModal(html: string) {
        const assetListModal = document.getElementById('assetListModal');
        if (assetListModal !== null) {
            this.modal = new Modal(assetListModal, { backdrop: 'static', keyboard: false });

            if (this.modal !== null) {
                this.modal.show();
            }
        }
    }
}